import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PostalMailActions } from "../_store/PostalMail.slice";
import PdfViewer from '../components/common/PdfViewer';
import { DocumentsActions } from '../_store/document.slice';
import Table from '../components/common/CustomTable';
import Button from '../components/common/ui/Button';
import CustomModal from '../components/common/CustomModal ';
import Loader from '../components/common/Loader';
import { KioskDashboardActions } from '../_store';
import TranslateFile from '../Loc/TranslateFile';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../src/_helpers/storageHelper";

const PostalMail = () => {
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const [LoadKioskMailDocumentSearchDetails, setLoadKioskMailDocumentSearchDetails] = useState([]);
    const { DownloadFileFromPathResponses } = useSelector(state => state.Documents);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const dispatch = useDispatch();
    const [isshowListPage, setisshowListPage] = React.useState(true);
    const [loading, setLoading] = useState(false);
    const [showPopup, setshowPopup] = React.useState(false);
    const currentLang = TranslateFile();
    const { isPageReload: isPageReloading, isSignalRData } = useSelector((state) => state.auth);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    useEffect(() => {
        switch (isSignalRData?.type) {
            // case 'Send_PostalMail':
            //     var Objectdata = {
            //         activeStatus: 1, sortBy: "MailScanningDocumentID DESC", documentTitle: '', documentUploadStartDate: '', documentUploadEndDate: '',
            //         facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
            //     };
            //     dispatch(PostalMailActions.getLoadKioskMailDocumentSearch(Objectdata)).then(x => {
            //         setLoadKioskMailDocumentSearchDetails(x?.payload);
            //         setLoading(false);
            //     });
            //     break;
            case 'Reject_PostalMail':
                const updatePostalMail = LoadKioskMailDocumentSearchDetails?.filter((x) =>
                    x?.MailScanningDocumentID != isSignalRData?.message?.MailScanningDocumentID
                )
                setLoadKioskMailDocumentSearchDetails(updatePostalMail);
                break;
        }
    }, [isSignalRData])

    useEffect(() => {
        setisshowListPage(true)
        PageOnLoad();
    }, [isPageReloading]);

    const PageOnLoad = () => {
        setLoading(LoadKioskMailDocumentSearchDetails?.length > 0 ? false : true);
        var Objectdata = {
            activeStatus: 1, sortBy: "MailScanningDocumentID DESC", documentTitle: '', documentUploadStartDate: '', documentUploadEndDate: '',
            facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        };
        dispatch(PostalMailActions.getLoadKioskMailDocumentSearch(Objectdata)).then(x => {
            setLoadKioskMailDocumentSearchDetails(x?.payload);
            setLoading(false);
        });
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(date)
            .replace(',', '');
    };

    const columns = [
        {
            name: currentLang?.TableHeaders?.Mail_From, width: '600px', selector: (row) => row.MailFrom, sortable: true,
            cell: (row) => (
                (
                    <div className="d-flex align-items-center" onClick={() => { handleONCLick(row) }}>
                        <span> <i className="fa fa-user-circle font-size-16 me-2 color-gray"></i></span>
                        <div className="request-text" dangerouslySetInnerHTML={{ __html: row?.MailFrom }} />
                    </div>
                )
            ),
            sortFunction: (a, b) => a.MailFrom.toLowerCase().localeCompare(b.MailFrom.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Mail_Date, selector: (row) => formatDate(row.CreatedDate), sortable: true,
            sortFunction: (a, b) => new Date(a.CreatedDate) - new Date(b.CreatedDate),
        },
        {
            name: currentLang?.TableHeaders?.Status, width: '120px', selector: (row) => row.IsReceiverRead, sortable: true,
            cell: (row) => (
                <div className="d-flex " title={row.IsReceiverRead == 1 ? 'Read' : 'Unread'} onClick={() => { handleONCLick(row) }}>
                    {PhotoReadStatus(row.IsReceiverRead)}
                </div>
            ),
        },
    ];

    const PhotoReadStatus = (status) => {
        return <span className={`${status == 1 ? 'StatusSent' : 'StatusPatch-danger'}`}>{status == 1 ? 'Read' : 'Unread'}</span>;
    };

    const getfolderPath = (fileSavedPath) => {
        const lastIndex = fileSavedPath?.lastIndexOf("/") + 1; // Get the index of the last '/'
        return fileSavedPath?.substring(0, lastIndex)?.trimEnd(); // Get the substring and trim any trailing spaces
    };


    const handleONCLick = (item) => {
        setLoading(true);
        var Objectdata = {
            activeStatus: 1, sortBy: "MailScanningDocumentID DESC", documentTitle: '', documentUploadStartDate: item?.CreatedDate,
            documentUploadEndDate: item?.CreatedDate, facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        };
        dispatch(PostalMailActions.getLoadKioskMailDocumentSearch(Objectdata))
            .then((x) => {
                const result = x?.payload;
                const selectmaildoc = result?.find(x => x?.IsApprove == 1 && x?.MailScanningDocumentID === item?.MailScanningDocumentID);
                if (selectmaildoc?.MailScanningDocumentID) {

                    let folderPath = getfolderPath(selectmaildoc?.DocumentPath);
                    if (process.env.REACT_APP_FOLDER_PATH && process.env.REACT_APP_FOLDER_PATH.trim() !== "") {
                        folderPath = `${process.env.REACT_APP_FOLDER_PATH}${getfolderPath(selectmaildoc?.DocumentPath)}`;
                    }

                    if (folderPath?.length > 0) {
                        var filename = selectmaildoc?.DocumentFileName;
                        dispatch(DocumentsActions.getDownloadFileFromPath({ folderPath, filename })).then(x => {
                            if (x?.payload) {
                                setisshowListPage(false); setLoading(false);
                                if (selectmaildoc?.IsReceiverRead == 0) {
                                    dispatch(PostalMailActions.loadUpdatePostalMailReadStatus(selectmaildoc?.MailScanningDocumentID)).then(x => {
                                        const podCode = storedLoginDetails?.PodCode;
                                        const inmateID = storedloginResponse?.InmateID;
                                        if (inmateID && podCode)
                                            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
                                    })
                                }
                            }
                            else {
                                setshowPopup(true); setLoading(false);
                            }
                        });
                    }
                    else {
                        setshowPopup(true); setLoading(false);
                    }
                }
                else {
                    setshowPopup(true); setLoading(false); PageOnLoad();
                }
            })
    }

    return (
        <div className="dashboard-container">

            <div className="dashboard-content">

                <div className="d-flex justify-content-between mb-1 pt-1">
                    <div className="align-self-start">
                        <div className="icon-container">
                            <h3 className="find-inmate-head">{currentLang?.Postal_Mail}</h3>
                        </div>
                    </div>
                    {!isshowListPage && <div className="align-self-end">
                        <Button className='btn-danger' label={currentLang?.Buttons?.Back} type="button" status="back" onClick={() => { setisshowListPage(true); PageOnLoad() }} />
                    </div>}
                </div>
                <div className="divider mb-3"></div>
                <div className="card-default">
                    {isshowListPage ?
                        (LoadKioskMailDocumentSearchDetails?.length > 0 ?
                            <Table isScrollContainer={true} columns={columns} data={LoadKioskMailDocumentSearchDetails} pagination handleONCLick={handleONCLick} />
                            :
                            (!loading && <span className="col-no-data">{currentLang?.No_Data_Found}</span>)
                        )
                        : <PdfViewer base64={DownloadFileFromPathResponses} />
                    }

                </div>
                {loading && <Loader />}
                {showPopup && (
                    <CustomModal color={'#c8605e'} content={currentLang?.AlertPopup?.File_not_exist_in_uploaded_directory} onOkClick={() => { setshowPopup(false) }} ></CustomModal>
                )}
            </div>

        </div>
    );
};

export default memo(PostalMail);
